import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import { signalrActions } from "../../../../redux/signalr";
import useSetGuard from "../../../../hooks/useSetGuard";

const useAssinarProrrogacao = () => {
  const { request: requestSafePayload, data: dataSafePayload } = useApiClient();
  const { request, data, errors, isLoading } = useApiClient();
  const setGuardClient = useSetGuard();
  const { filaAssinaturaSucessoStateKey, filaAssinaturaFalhaStateKey } = useSelector((state) => state.signalr);
  const dispatch = useDispatch();

  useEffect(() => {
    if (filaAssinaturaSucessoStateKey) {
      toast.success("Assinatura de Documento realizada com sucesso.");
      window.location.reload();
    }
    return () => {
      dispatch(signalrActions.clearState("filaAssinaturaSucessoStateKey"));
    };
  }, [dispatch, filaAssinaturaSucessoStateKey]);

  useEffect(() => {
    dispatch(signalrActions.clearState("filaAssinaturaFalhaStateKey"));
  }, [dispatch, filaAssinaturaFalhaStateKey]);

  const AssinarSolicitacao = useCallback(
    (ordemServico, pedidoProrrogacao, acaoFiscal, usuario, txJustificativa, txProrrogacao) => {
      const params = {
        SqPedidoProrrogacao: pedidoProrrogacao?.sqPedidoProrrogacao ?? 0,
        SqOrdemServico: ordemServico,
        SqAcaoFiscal: acaoFiscal,
        TxJustificativa: txJustificativa,
        TxProrrogacao: txProrrogacao,
        NomeAuditor: usuario.nome,
        MatriculaAuditor: usuario.matricula,
        SiglaOrgaoAuditor: usuario.siglaOrgao,
      };

      request(apiRoutes.fiscalizacao.prorrogacaoos.assinarSolicitarProrrogacaoOs, params);
    },
    [request],
  );

  useEffect(() => {
    if (isLoading) return;

    if (!data && !errors) return;

    if (data) {
      requestSafePayload(apiRoutes.usuarios.arquivo.selecionar, data.result);
    } else if (errors) {
      toast.error(errors.message);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors, isLoading, requestSafePayload]);

  const assinaturaHandler = useCallback(
    (safePayload) => {
      setGuardClient.assinar(safePayload);
    },
    [setGuardClient],
  );

  useEffect(() => {
    if (dataSafePayload) {
      assinaturaHandler(dataSafePayload.result);
    }
  }, [dataSafePayload, assinaturaHandler]);

  return { isLoading, AssinarSolicitacao, setGuardClient };
};

export default useAssinarProrrogacao;
